module.exports = __webpack_public_path__ + "img/btn-night.488fe3da.png";